import Vue from 'vue'
import {CONFIG} from './config.js';

const ContactForm = Vue.component('contact_form', {
    data: function() {
        return {
            subject: null,
            text: null,
            subjectChanged: false,
            textChanged: false,
            showConfirm: false
        }
    },
    mounted: function() {
        this.$ebus.$emit('menu:update', {component: 'menu-contact'});
    },
    destroyed: function() {
        this.$ebus.$emit('menu:reset');
    },
    methods: {
        onSubmit: function(evt) {
            evt.preventDefault();
            this.$ebus.$emit("msg:clear");
            var self = this;

            if (this.isSubjectValid && this.isTextValid) {
                this.$protected("post", CONFIG.api.endpoints.email,
                    function(r) {
                        self.resetForm();
                        self.showConfirm = true;
                    },
                    {
                        data: {
                            request_text_: self.text,
                            request_subject_: self.subject,
                            source_url_: window.location.origin + self.$store.state.previousRoute,
                        }
                    })
            }
        },
        resetForm: function() {
            this.text = null;
            this.subject = null;
        }
    },
    watch: {
        text: function(v) {
            if (v === null) {
                this.textChanged = false;
            }
        },
        subject: function(v) {
            if (v === null) {
                this.subjectChanged = false;
            }
        }
    },
    computed: {
        subjectInvalidFeedback: function() {
            if (this.subjectChanged) {
                if (!this.subject) {
                    return this.$t("contactForm.error.subject.empty");
                }
            }

            return '';
        },
        isSubjectValid: function() {
            return true;
        },
        textInvalidFeedback: function() {
            if (this.textChanged) {
                if (!this.text) {
                    return this.$t("contactForm.error.text.empty");
                } else if (!this.isTextValid) {
                    return this.$t("contactForm.error.text.invalid");
                }
            }

            return '';
        },
        isTextValid: function() {
            if (!this.textChanged) {
                return null;
            }

            return this.text != null && this.text.length > 0;
        },
    },
    template: '#contact_form'
})

export default ContactForm;